var map = {
	"./PRESS-SLIDE1.png": 53593,
	"./PRESS-SLIDE2.png": 63683,
	"./PRESS-SLIDE3.png": 32642,
	"./carousel-01.png": 98863,
	"./carousel-02.png": 64268,
	"./carousel-03.png": 71359,
	"./carousel-bg.jpg": 38399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45208;